import {ConfigProvider} from './config/ConfigProvider'
import {RouteDefinition, Router} from '@solidjs/router'
import {createEffect, createSignal, Show} from 'solid-js'
import {AuthorizationProvider} from '../authorization'
import {ReduxProvider, StoreOptions, useSelector} from '../store'
import {ToastProvider} from './toast/ToastProvider'
import {IconProvider} from './icon/IconProvider'
import {ToastPosition} from './toast/Toast'
import {GenericWrapper} from './GenericWrapper'
import {ThemeProvider} from './index'
import {NotificationHandling} from './notification-handling/NotificationHandling'
import {CareAgentAuthorizationProvider} from '../../../careAgent/authorization'
import {RouterWrapper} from '../router/RouterWrapper'

export interface AppProvidersProps {
    children: any
    storeOptions: StoreOptions
    defaultConfig: any
    getRoutes: (indexRoute?: string) => RouteDefinition[]
    icons?: {[k: string]: any}
    toastPosition?: ToastPosition
    ignoredNotification: string[]
}
const AppProviders = (props: AppProvidersProps) => {
    const state = useSelector((state: any) => state)

    const getAuthorizationProvider = () => {
        let isAgent = location.pathname.includes('agent')
        let Provider = isAgent ? CareAgentAuthorizationProvider : AuthorizationProvider
        return (
            <Provider voltApi={props.storeOptions.voltApi}>
                <Show when={state()}>
                    <ThemeProvider>
                        <GenericWrapper>
                            <RouterWrapper getRoutes={props.getRoutes} />
                        </GenericWrapper>
                    </ThemeProvider>
                </Show>
            </Provider>
        )
    }
    return (
        <ConfigProvider defaultConfig={props.defaultConfig}>
            <ReduxProvider
                voltApi={props.storeOptions.voltApi}
                configureStoreFactory={props.storeOptions.configureStoreFactory}
            >
                <IconProvider icons={props.icons || {}}>
                    <ToastProvider toastPosition={props.toastPosition}>
                        <NotificationHandling
                            ignoredNotification={props.ignoredNotification}
                            errorCodes={props.storeOptions.voltApi.VoltError.codes}
                        >
                            {getAuthorizationProvider()}
                        </NotificationHandling>
                    </ToastProvider>
                </IconProvider>
            </ReduxProvider>
        </ConfigProvider>
    )
}

export default AppProviders
